import { trim, upperFirst } from 'lodash'
import { generateUniqueName } from '@wix/wix-data-client-common-standalone'
import fetchControllersData from '../../business-logic/controllers/fetchControllersData'

const validateDisplayName = displayName => displayName && trim(displayName)

const defaultDisplayName = collectionName =>
  `${upperFirst(collectionName)} dataset`

const fetchExistingControllerNames = async editorSdkProxy => {
  const controllersData = await fetchControllersData(editorSdkProxy)
  return controllersData.map(({ displayName }) => displayName)
}

const generateUniqueDisplayName = async ({ editorSdkProxy, collection }) => {
  const existingNames = await fetchExistingControllerNames(editorSdkProxy)

  const collectionName = collection.displayNamespace
    ? `${collection.displayNamespace}/${collection.displayName}`
    : collection.displayName

  return generateUniqueName(
    (prefix, i) => `${prefix} ${i}`,
    defaultDisplayName(collectionName),
    existingNames,
    {
      allowNameWithoutSuffix: true,
      startIndex: 2,
    },
  )
}

export {
  validateDisplayName,
  generateUniqueDisplayName,
  fetchExistingControllerNames,
}
